import { stringify as s, parse as p } from 'query-string'

import { COMPANY_PROFILE } from '../config'
import { SearchTypes, JOB } from '../search/constants'

import { filter } from './object'
import { isNone, not, parseIntOrUndef } from './primitive'
import { DEFAULT_SEARCH_PARAMETERS } from './search'

export function parse (locationString = '', defaultType = JOB) {
  const parsed = p(locationString)
  const {
    plz: plzString,
    type,
    'job-id': jobId,
    'company-id': companyId,
    ...query
  } = parsed
  const [location, dist, cc] = plzString ? plzString.split(':') : []

  return {
    ...DEFAULT_SEARCH_PARAMETERS,
    ...filter({
      ...query,
      ...{ location, dist: parseIntOrUndef(dist), cc },
      type: type in SearchTypes ? type : defaultType,
      jobId: parseIntOrUndef(jobId),
      companyId: parseIntOrUndef(companyId)
    }, not(isNone))
  }
}

export function format ({ location, dist, cc, type, jobId, companyId, ...query }) {
  return filter({
    ...query,
    ...{ plz: location && [location, ...(dist ? [dist, ...(cc ? [cc] : [])] : [])].join(':') },
    ...{ type },
    ...{ 'job-id': jobId, 'company-id': companyId }
  }, not(isNone))
}

/**
 *
 * @param {Object} location Domain specific location
 * @param {string} location.country_name Location country
 * @param {string} location.country_code Location country code
 * @param {string} location.name Location name ex: Berlin Main Office
 * @param {string} location.city Location city
 * @param {Object} options Options to specify how location is represented
 * @param {string} [options.displayProp=city] Field that will be used to construct string representation for the provided location
 * @returns {string|null} Return string representation for the current domain location object
 */
export function formatLocation (location, { displayProp = 'city' } = {}) {
  if (!location) return null
  const {
    country_name: countryName,
    country_code: countryCode,
    [displayProp]: displayField
  } = location
  if (!displayField) {
    if (displayProp === 'name' && countryName) {
      return countryName
    } else {
      return null
    }
  }
  if (COMPANY_PROFILE.HIDDEN_COUNTRY_CODES.includes(countryCode)) {
    return displayField
  }
  if (!countryName) return null
  return `${displayField}, ${countryName}`
}

export const stringify = query => s(format(query))
